import React, { useRef, useState } from "react";
import { imageUrl } from "../lib/api";
import { uploadImage } from "./uploadImage";
import { Upload, X, Loader2 } from "lucide-react";

export default function ImageField({ value, onChange, label, small }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const id = await uploadImage(file);
      onChange(id);
    } catch (err) {
      alert("Upload failed. Please try a smaller image.");
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  const h = small ? "h-28" : "h-44";

  return (
    <div>
      {label && <div className="text-sm text-[#9aa4af] mb-1.5">{label}</div>}
      {value ? (
        <div className={`relative ${h} rounded-lg overflow-hidden group border border-white/10`}>
          <img src={imageUrl(value)} alt="" className="w-full h-full object-cover" />
          <button type="button" onClick={() => onChange(null)} className="absolute top-2 right-2 w-8 h-8 rounded-full bg-black/60 text-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
            <X className="w-4 h-4" />
          </button>
        </div>
      ) : (
        <button type="button" onClick={() => inputRef.current?.click()} disabled={busy} className={`w-full ${h} rounded-lg border-2 border-dashed border-white/15 flex flex-col items-center justify-center gap-2 text-[#6b7683] hover:border-[#2f9fe6] hover:text-[#2f9fe6] transition-colors`}>
          {busy ? <Loader2 className="w-6 h-6 animate-spin" /> : <Upload className="w-6 h-6" />}
          <span className="text-xs">{busy ? "Uploading..." : "Upload image"}</span>
        </button>
      )}
      <input ref={inputRef} type="file" accept="image/*" onChange={handle} className="hidden" />
    </div>
  );
}
